export default {
  name: 'sla',
  translationKey: 'sla-module',
  routePrefix: 'sla',
  routeNamePrefix: 'admin.sla',
  directRoutesAvailable: false,
}
